import { useEffect, useState } from "react";
import AudiosService from "../Services/Audios";
import WithoutLyrics from "../Images/audiolyrics.svg";
import WithLyrics from "../Images/audiowithoutlyrics.svg";
import { Breadcrumbs } from "./E-BooksComponent";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import imgpause from "../assets/audioPlayer/img/yellowplay.svg";
import imgdownload from "../Images/downloadpravachan.svg";
import ListPagination from "../Components/ListPagination";
import Loader from "./Loader";
import { LogInModel } from "./LoginModel";
import i18n from "../i18n";

const DailySatsangPage = () => {
    const UserIdentity = localStorage.getItem("UserId") as any;
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [podcastData, setPodcastData] = useState<any[] | undefined | any>(undefined);
    const [logIn, setLogIn] = useState<boolean>(false);
    const [ItemtoPlay, setItemtoPlay] = useState<any>(null);

    const closeModal = () => {
        setLogIn(false);
    };

    const [refresh, setRefresh] = useState(false);
    const [pagination, setPagination] = useState({
        pageNo: 1,
        recordsPerPage: 12,
        totalRecords: 0,
    });

    var timestamp = new Date().getTime();
    const encoded = btoa(timestamp.toString());

    const [loading, setLoading] = useState(true);

    const handleLoginStateChange = (newState: any) => {
        if (newState === true && ItemtoPlay) {
            localStorage.setItem("type", "DailySatsang");
            const slugToUse = ItemtoPlay.audioslug || ItemtoPlay.description || "";
            console.log("slugToUse", slugToUse);
            navigate(`/DailySatsang/${encodeURIComponent(slugToUse)}`, {
                state: {
                    audioId: ItemtoPlay.audioId,
                    audioslug: slugToUse,
                    index: ItemtoPlay.index,
                    pageNum: ItemtoPlay.pageNum,
                },
            });
            setItemtoPlay(null); // Clear the item to play
        }
    };

    const downloadDailySatsang = (pravachanPath: any) => {
        const imageUrl = pravachanPath;
        const link = document.createElement('a');
        link.href = imageUrl; link.download = 'image.jpg';
        document.body.appendChild(link); link.click();
        document.body.removeChild(link);
    };

    useEffect(() => {
        setRefresh(false);
        const fetchData = async () => {
            try {
                const response = await AudiosService.getDailySatsang(
                    "",
                    pagination.pageNo === 0
                        ? 0
                        : pagination.recordsPerPage * pagination.pageNo - 12,
                    pagination.recordsPerPage,
                    "",
                    "",
                    "",
                    "",
                    "",
                    0
                )
                const res = await response;
                setPodcastData(res.result?.items);
                setPagination({
                    ...pagination,
                    totalRecords: res.result?.totalRecords,
                });
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false); // Hide loader after fetching
            }
        }
        fetchData();
    }, [refresh, i18n.language])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div style={{ marginBottom: "20px" }}>
            <Breadcrumbs
                mainsubBreadCrumb={t("daily_satsang_tr")}
                subBreadCrumb={t("Home_tr")}
                navigatemainsubBreadCrumb={() => {
                    navigate(`/home`);
                }}
                subBreadCrumbTwo={t("daily_satsang_tr")}
                navigatesubBreadCrumb={() => {
                }}
            />
            <div>
                <div className="containers">
                    <div
                        className="filter1"
                        style={{ margin: "5px 0" }}
                    >
                        <span>
                            {t("Total_Records_tr")} : {pagination?.totalRecords}
                        </span>
                    </div>
                    {podcastData?.length >= 0 ?
                        <div className="row">
                            <div className="podcastbox">
                                {podcastData?.map((data: any, i: number) => {
                                    return (
                                        <div key={`data-${data.id}`}>
                                            <div className="sidebarmargin">
                                                <div
                                                    className="pravchanBox"
                                                    style={{ display: "flex", padding: "15px 20px", cursor: "pointer" }}
                                                >
                                                    <div style={{ marginRight: "25px" }}>
                                                        <a>
                                                            <img
                                                                className="audioicon"
                                                                src={
                                                                    data.lyricsHash != null
                                                                        ? WithLyrics
                                                                        : WithoutLyrics
                                                                }
                                                                onError={(e) => {
                                                                    e.currentTarget.src = WithoutLyrics;
                                                                }}
                                                                alt={data.name}
                                                                title={data.name}
                                                                onClick={() => {
                                                                        if (UserIdentity) {
                                                                        localStorage.setItem("type", "DailySatsang")
                                                                        const slugToUse = data?.slug || data?.description || "";
                                                                        console.log("slugToUse", slugToUse);
                                                                        navigate(`/DailySatsang/${encodeURIComponent(slugToUse)}`, {
                                                                            state: {
                                                                                audioId: data?.id,
                                                                                audioslug: slugToUse,
                                                                                index: i,
                                                                                pageNum: pagination.pageNo,
                                                                            },
                                                                        });
                                                                    } else {
                                                                        setItemtoPlay({
                                                                            description: data?.description,
                                                                            audioId: data?.id,
                                                                            audioslug: data?.slug || data?.description,
                                                                            index: i,
                                                                            pageNum: pagination.pageNo,
                                                                        });
                                                                        setLogIn(true);
                                                                    }
                                                                }}
                                                            />
                                                        </a>
                                                    </div>
                                                    <div style={{ width: "100%" }}>
                                                        <a
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => {
                                                                const slugToUse = data?.slug || data?.description || "";

                                                                console.log("slug", data?.slug);
                                                                console.log("description", data?.description);

                                                                if (UserIdentity) {
                                                                    localStorage.setItem("type", "DailySatsang")
                                                                    navigate(`/DailySatsang/${encodeURIComponent(slugToUse)}`, {
                                                                        state: {
                                                                            audioId: data?.id,
                                                                            audioslug: slugToUse,
                                                                            index: i,
                                                                            pageNum: pagination.pageNo,
                                                                        },
                                                                    });
                                                                } else {
                                                                    setItemtoPlay({
                                                                        description: data?.description,
                                                                        audioId: data?.id,
                                                                        audioslug: slugToUse,
                                                                        index: i,
                                                                        pageNum: pagination.pageNo,
                                                                    });
                                                                    setLogIn(true);
                                                                }
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    fontSize: "25px",
                                                                    paddingTop: "3px",
                                                                    fontWeight: "600",
                                                                    textAlign: "unset",
                                                                }}
                                                            >
                                                                <p>
                                                                    {/* {data.name != null &&
                                                                data.name.length > 100
                                                                ? data.name.slice(0, 80) + "..."
                                                                : data.name} */}
                                                                    {data?.name}
                                                                </p>
                                                            </p>
                                                            <div style={{ display: "grid" }}>
                                                                <label>{data.description}</label>
                                                                <label>{data.audioLength}</label>
                                                                {/* <label>{convertLengthToTime(data?.audioLength)}</label> */}
                                                            </div>
                                                        </a>
                                                    </div>
                                                    <div className="btns">
                                                        <div className="buttonres">
                                                            <a
                                                                id="download"
                                                                title="Download"
                                                                onClick={() => {
                                                                    if (UserIdentity) {
                                                                        downloadDailySatsang(data.audioPath != null
                                                                            ? data.audioPath + "?t=" + encoded + "&download_attachment=true"
                                                                            : "no record found")
                                                                    } else {
                                                                        setLogIn(true);
                                                                    }
                                                                }}
                                                            >
                                                                <img
                                                                    alt="download"
                                                                    src={imgdownload}
                                                                    className="downloadbtn"
                                                                ></img>
                                                            </a>
                                                        </div>
                                                        <div
                                                            style={{
                                                                cursor: "pointer",
                                                                paddingLeft: "5px",
                                                            }}
                                                        >
                                                            <img
                                                                alt=""
                                                                onClick={() => {
                                                                        localStorage.setItem("type", "DailySatsang")
                                                                        const slugToUse = data?.slug || data?.description || "";
                                                                        console.log("slugToUse", slugToUse);
                                                                        if (UserIdentity) {
                                                                            navigate(`/DailySatsang/${encodeURIComponent(slugToUse)}`, {
                                                                                state: {
                                                                                    audioId: data.id,
                                                                                    audioslug: slugToUse,
                                                                                    index: i,
                                                                                    pageNum: pagination.pageNo,
                                                                                },
                                                                            });
                                                                        } else {
                                                                            setItemtoPlay({
                                                                                description: data?.description,
                                                                                audioId: data?.id,
                                                                                audioslug: slugToUse,
                                                                                index: i,
                                                                                pageNum: pagination.pageNo,
                                                                            });
                                                                            setLogIn(true);
                                                                        }
                                                                    }}
                                                                title="Play"
                                                                src={imgpause}
                                                                className="playbtn"
                                                            ></img>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                )}
                            </div>
                            <div className="col-12" style={{ marginTop: "30px", display: pagination.totalRecords <= 12 ? "none" : "block" }}>
                                <ListPagination
                                    totalRecords={pagination.totalRecords}
                                    recordsPerPage={pagination.recordsPerPage}
                                    currentPage={pagination.pageNo}
                                    onClick={(p) => {
                                        setPagination({
                                            ...pagination,
                                            pageNo: p,
                                        });
                                        setRefresh(true);
                                    }}
                                />
                            </div>
                        </div>
                        :
                        <div className="ebooks-category resultnotfound">
                            {loading && <Loader loading={loading} />}
                            {t("result_not_found_tr")}
                        </div>
                    }
                </div>
                <LogInModel opens={logIn} onCloses={closeModal} onLoginStateChange={handleLoginStateChange} />
            </div>
        </div>
    )
}
export default DailySatsangPage;